import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

const statusPillVariants = cva("app-pill-status", {
  variants: {
    tone: {
      default: "",
      success:
        "border-green-200 bg-green-100 text-green-700 dark:border-green-400/20 dark:bg-green-400/10 dark:text-green-300",
      warning:
        "border-softiq-secondary-shade-300 bg-softiq-secondary-shade-100 text-softiq-secondary-shade-900 dark:border-softiq-secondary/30 dark:bg-softiq-secondary/10 dark:text-softiq-secondary-shade-200",
      danger:
        "border-red-200 bg-red-100 text-red-700 dark:border-red-400/20 dark:bg-red-400/10 dark:text-red-300",
      neutral:
        "border-gray-200 bg-gray-100 text-softiq-primary dark:border-white/10 dark:bg-white/10 dark:text-white",
    },
    appearance: {
      default: "",
      flat: "border-0 shadow-none",
    },
  },
  defaultVariants: {
    tone: "default",
    appearance: "default",
  },
});

export type StatusPillProps = HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof statusPillVariants>;

export function StatusPill({
  className,
  tone,
  appearance,
  ...props
}: StatusPillProps) {
  return (
    <span
      className={cn(statusPillVariants({ tone, appearance }), className)}
      {...props}
    />
  );
}
